module.exports = __webpack_public_path__ + "img/homepage-banners-mazda-compliant-honda.237aac58.jpg";